import { render, staticRenderFns } from "./index.vue?vue&type=template&id=251329bb&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251329bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('251329bb')) {
      api.createRecord('251329bb', component.options)
    } else {
      api.reload('251329bb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=251329bb&scoped=true", function () {
      api.rerender('251329bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/organizationArchitecture/components/Detail/index.vue"
export default component.exports